/* Add one cart line per size-qty box. Do not let Debut serialize the selected variant + total qty. */
(function () {
  function sectionIdFrom(scope) {
    if (!scope) return "";
    if (scope.getAttribute && scope.getAttribute("data-section-id")) return scope.getAttribute("data-section-id");
    if (scope.id && scope.id.indexOf("ProductSection-") === 0) return scope.id.slice("ProductSection-".length);
    var el = (scope.querySelector && scope.querySelector("[data-section-id]")) || null;
    if (el) return el.getAttribute("data-section-id") || "";
    return "";
  }

  function variantByOptions(scope) {
    var map = {};
    var sid = sectionIdFrom(scope);
    var invEl = sid ? document.getElementById("VariantInventoryJson-" + sid) : null;
    if (invEl) {
      try {
        var data = JSON.parse((invEl.textContent || "").trim() || "{}");
        if (data && data.byOptions) {
          Object.keys(data.byOptions).forEach(function (k) {
            map[k] = String(data.byOptions[k]);
          });
        }
      } catch (err) {}
    }
    var pj = sid ? document.getElementById("ProductJson-" + sid) : null;
    if (pj) {
      try {
        var prod = JSON.parse(pj.textContent || "{}");
        (prod.variants || []).forEach(function (v) {
          var opts = v.options || [v.option1, v.option2, v.option3].filter(Boolean);
          var k = opts.join("|");
          if (k && v.id) map[k] = String(v.id);
        });
      } catch (err2) {}
    }
    return map;
  }

  function currentColor(scope) {
    var sel = scope && scope.querySelector && scope.querySelector("[data-ezink-color-select]");
    if (sel && sel.value) return sel.value;
    return "";
  }

  function findVariantId(map, color, size) {
    if (!map || !color || !size) return "";
    var tries = [color + "|" + size, size + "|" + color];
    var i;
    for (i = 0; i < tries.length; i++) {
      if (map[tries[i]]) return map[tries[i]];
    }
    var prefix = color + "|";
    var k;
    for (k in map) {
      if (!Object.prototype.hasOwnProperty.call(map, k)) continue;
      if (k.indexOf(prefix) === 0 && k.slice(prefix.length) === size) return map[k];
    }
    return "";
  }

  function sizeLines(scope) {
    var out = [];
    if (!scope) return out;
    if (window.ezinkSizeQty && typeof window.ezinkSizeQty.rebuild === "function") {
      try { window.ezinkSizeQty.rebuild(); } catch (err) {}
    }
    var color = currentColor(scope);
    var map = variantByOptions(scope);
    var grid = scope.querySelector("[data-ezink-size-qty-grid]") || scope;
    var seen = {};
    grid.querySelectorAll("[data-ezink-size-qty-input]").forEach(function (inp) {
      if (inp.disabled) return;
      var n = parseInt(inp.value, 10) || 0;
      if (n < 1) return;
      var max = parseInt(inp.getAttribute("max"), 10);
      if (!isNaN(max) && n > max) n = max;
      var size = inp.getAttribute("data-size") || "";
      var id = String(inp.getAttribute("data-variant-id") || "").trim();
      var resolved = findVariantId(map, color, size);
      if (resolved) id = resolved;
      if (!/^\d+$/.test(id)) return;
      if (seen[id]) return;
      seen[id] = true;
      var productCloseout = scope.getAttribute && scope.getAttribute("data-ezink-closeout") === "1";
      out.push({
        id: Number(id),
        quantity: n,
        size: size,
        closeout: !!(productCloseout || inp.getAttribute("data-ezink-closeout") === "1")
      });
    });
    return out;
  }

  function formProperties(form) {
    var props = {};
    if (!form || !form.elements) return props;
    Array.prototype.forEach.call(form.elements, function (el) {
      if (!el.name || el.disabled) return;
      var match = String(el.name).match(/^properties\[([^\]]+)\]$/);
      if (!match) return;
      if (el.type === "file" || el.tagName === "BUTTON") return;
      if ((el.type === "checkbox" || el.type === "radio") && !el.checked) return;
      var val = el.value == null ? "" : String(el.value).trim();
      if (!val) return;
      props[match[1]] = val;
    });
    return props;
  }

  function locLabel(item) {
    return (item.getAttribute("data-art-label") || "").trim() || "Front";
  }

  function locSlug(loc) {
    return String(loc || "front")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "_")
      .replace(/^_|_$/g, "") || "front";
  }

  function stripScheme(url) {
    return String(url || "").trim().replace(/^https?:\/\//i, "");
  }

  function publicArtUrl(url) {
    var raw = String(url || "").trim();
    if (!raw || /^(javascript|data):/i.test(raw)) return "";
    if (/^https?:\/\//i.test(raw)) return raw;
    if (raw.indexOf("//") === 0) return "https:" + raw;
    return "https://" + raw.replace(/^\/+/, "");
  }

  function artToken(url) {
    var raw = String(url || "").trim();
    var m = raw.match(/\/shopify\/artwork\/([0-9a-f]{32}\/[^/?#]+)/i);
    if (m) return m[1];
    return stripScheme(raw);
  }

  function artItems(form) {
    var nodes = form ? form.querySelectorAll("[data-ezink-art-item]") : [];
    if (nodes && nodes.length) return nodes;
    var pdp = document.querySelector("[data-ezink-art-pdp]");
    return pdp ? pdp.querySelectorAll("[data-ezink-art-item]") : [];
  }

  function collectArtwork(form) {
    var props = formProperties(form);
    var files = [];
    var locations = [];
    artItems(form).forEach(function (item) {
      var loc = locLabel(item);
      var slug = locSlug(loc);
      var wEl = item.querySelector("[data-ezink-art-w]");
      var hEl = item.querySelector("[data-ezink-art-h]");
      var w = parseFloat(wEl && wEl.value);
      var h = parseFloat(hEl && hEl.value);
      var sizeLabel = w > 0 && h > 0 ? w + "×" + h + " in" : "";
      var tField = item.querySelector("[data-ezink-art-transfer-field]");
      var tSel = item.querySelector("[data-ezink-art-transfer]");
      var tLabel = (tField && tField.value) || "";
      if (!tLabel && tSel && tSel.selectedIndex >= 0 && tSel.options[tSel.selectedIndex]) {
        tLabel = tSel.options[tSel.selectedIndex].text || "";
      }
      var linkEl = item.querySelector("[data-ezink-art-link]");
      var notesEl = item.querySelector("[data-ezink-art-notes]");
      var fileInp = item.querySelector("[data-ezink-file], input[type='file']");
      var file = fileInp && fileInp.files && fileInp.files[0] ? fileInp.files[0] : null;
      var rawLink = linkEl && linkEl.value.trim() ? linkEl.value.trim() : "";
      var link = rawLink ? stripScheme(rawLink) : "";
      if (/^(javascript|data):/i.test(rawLink) || /^(javascript|data):/i.test(link)) {
        rawLink = "";
        link = "";
      }
      var notes = notesEl && notesEl.value.trim() ? notesEl.value.trim() : "";
      if (file) files.push({ loc: loc, slug: slug, file: file });
      locations.push({
        loc: loc,
        slug: slug,
        sizeLabel: sizeLabel,
        typeLabel: tLabel,
        linkUrl: rawLink ? publicArtUrl(rawLink) : "",
        notes: notes,
        fileName: file ? file.name : "",
        fileUrl: "",
        token: ""
      });
    });
    return { props: props, files: files, locations: locations, hasArt: locations.length > 0 };
  }

  /* One block per location. Newlines so the Shopify order page can show a short stack.
     File name is its own line because admin shortens long https values. */
  function fileNameFromUrl(url) {
    var path = String(url || "").split("?")[0].split("#")[0];
    var name = path.split("/").pop() || "";
    try { name = decodeURIComponent(name); } catch (err) {}
    return name;
  }

  function buildArtSummary(locations) {
    var out = {};
    var names = [];
    var shorts = [];
    (locations || []).forEach(function (row) {
      if (!row || !row.loc) return;
      names.push(row.loc);
      var lines = [];
      var head = [];
      if (row.sizeLabel) head.push(row.sizeLabel);
      if (row.typeLabel) head.push(row.typeLabel);
      if (head.length) lines.push(head.join(" · "));
      var fileUrl = row.fileUrl || "";
      var linkUrl = row.linkUrl && row.linkUrl !== fileUrl ? row.linkUrl : "";
      var fileName = row.fileName || fileNameFromUrl(fileUrl) || fileNameFromUrl(linkUrl);
      if (fileName) lines.push("File: " + fileName);
      if (fileUrl) lines.push(fileUrl);
      if (linkUrl) lines.push(linkUrl);
      if (row.notes) {
        var note = String(row.notes).replace(/\s+/g, " ").replace(/\s+\|\s+/g, " / ").trim();
        if (note) lines.push("Notes: " + note);
      }
      var text = lines.join("\n");
      if (text.length > 900) text = text.slice(0, 900).replace(/\s+\S*$/, "") + "…";
      if (text) out["_Print | " + row.loc] = text;
      var brief = [row.loc];
      if (row.sizeLabel) brief.push(row.sizeLabel);
      if (row.typeLabel) brief.push(row.typeLabel);
      shorts.push(brief.join(" · "));
    });
    if (names.length) out["_Artwork locations"] = names.join("; ");
    if (shorts.length) out.Print = shorts.join("; ");
    return out;
  }

  function parseArtBlock(text) {
    var raw = String(text || "").replace(/\r\n/g, "\n").trim();
    var notes = "";
    var noteMatch = raw.match(/(?:^|\n)\s*Notes:\s*([\s\S]*)$/i) || raw.match(/\|\s*Notes:\s*([\s\S]*)$/i);
    if (noteMatch) {
      notes = String(noteMatch[1] || "").trim();
      raw = raw.slice(0, noteMatch.index).trim();
    }
    var size = "";
    var fileName = "";
    var urls = [];
    raw.split(/\n+|\s+\|\s+/).forEach(function (part) {
      var line = String(part || "").trim();
      if (!line) return;
      var urlMatch = line.match(/https?:\/\/\S+/i);
      if (urlMatch) {
        urls.push(urlMatch[0].replace(/[),.;]+$/, ""));
        return;
      }
      if (/^File:/i.test(line)) {
        fileName = line.replace(/^File:\s*/i, "").trim();
        return;
      }
      if (!size) size = line;
    });
    return { size: size, fileName: fileName, urls: urls, notes: notes };
  }

  function stampArt(props, locations) {
    if (!props || !locations || !locations.length) return;
    Object.keys(props).forEach(function (k) {
      if (
        k === "Print" ||
        k === "Decoration" ||
        k === "_Decoration" ||
        k === "Artwork locations" ||
        k === "_Artwork locations" ||
        k.indexOf("Print | ") === 0 ||
        k.indexOf("_Print | ") === 0 ||
        k.indexOf("Print size ") === 0 ||
        k.indexOf("_Print size ") === 0 ||
        k.indexOf("Print type ") === 0 ||
        k.indexOf("_Print type ") === 0 ||
        k.indexOf("Transfer ") === 0 ||
        k.indexOf("Artwork notes ") === 0 ||
        k.indexOf("Artwork link ") === 0 ||
        k.indexOf("Artwork file ") === 0 ||
        k.indexOf("Size — ") === 0 ||
        k.indexOf("Print type — ") === 0 ||
        k.indexOf("Artwork notes — ") === 0 ||
        k.indexOf("Artwork link — ") === 0 ||
        k.indexOf("_artlink_") === 0 ||
        k.indexOf("_artname_") === 0
      ) {
        delete props[k];
      }
    });
    var summary = buildArtSummary(locations);
    Object.keys(summary).forEach(function (k) { props[k] = summary[k]; });
  }

  function insertFileUrl(block, url) {
    var href = publicArtUrl(url);
    if (!href) return block || "";
    var text = block || "";
    if (text.indexOf(href) !== -1) return text;
    if (/custom\.ez-ink\.com\/shopify\/artwork\//.test(text)) return text;
    var name = fileNameFromUrl(href);
    var add = (name && text.indexOf("File: ") === -1 ? "File: " + name + "\n" : "") + href;
    if (!text) return add;
    if (text.indexOf("\nNotes:") !== -1) return text.replace("\nNotes:", "\n" + add + "\nNotes:");
    return text + "\n" + add;
  }

  function cartArtProps(props) {
    var keep = {};
    if (!props) return keep;
    if (props.Print) keep.Print = props.Print;
    if (props["_Artwork locations"]) keep["_Artwork locations"] = props["_Artwork locations"];
    if (props["Artwork locations"]) keep["Artwork locations"] = props["Artwork locations"];
    Object.keys(props).forEach(function (k) {
      if ((k.indexOf("Print | ") === 0 || k.indexOf("_Print | ") === 0) && props[k]) keep[k] = props[k];
    });
    ["_Artwork set", "_deco_each", "_set_qty", "_artfiles", "Blank acknowledgment", "Artwork rights"].forEach(function (k) {
      if (props[k]) keep[k] = props[k];
    });
    Object.keys(props).forEach(function (k) {
      if ((k.indexOf("_artwork_") === 0 || k.indexOf("_shopfile_") === 0) && props[k]) keep[k] = props[k];
    });
    return keep;
  }

  function postOne(item) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({
        id: Number(item.id),
        quantity: Number(item.quantity) || 1,
        properties: item.properties || {}
      })
    }).then(function (res) {
      return res.json().then(function (body) {
        if (!res.ok) throw new Error(body.description || body.message || "Could not add to cart");
        return body;
      });
    });
  }

  function postOneFd(id, qty, props, files) {
    var fd = new FormData();
    fd.append("id", String(id));
    fd.append("quantity", String(qty || 1));
    Object.keys(props || {}).forEach(function (k) {
      if (props[k] == null || props[k] === "") return;
      fd.append("properties[" + k + "]", String(props[k]));
    });
    (files || []).forEach(function (f) {
      if (!f || !f.file) return;
      var key = "_shopfile_" + (f.slug || locSlug(f.loc));
      fd.append("properties[" + key + "]", f.file, f.file.name || "artwork");
    });
    return fetch("/cart/add.js", {
      method: "POST",
      body: fd,
      headers: { Accept: "application/json" },
      credentials: "same-origin"
    }).then(function (res) {
      return res.json().then(function (body) {
        if (!res.ok) throw new Error(body.description || body.message || "Could not add to cart");
        return body;
      });
    });
  }

  var ART_UPLOAD = "https://custom.ez-ink.com/shopify/artwork";

  function uploadArtFile(file) {
    var fd = new FormData();
    fd.append("file", file, file.name || "artwork");
    return fetch(ART_UPLOAD, { method: "POST", body: fd }).then(function (res) {
      return res.json().then(function (body) {
        if (!res.ok || !body || !body.url) {
          throw new Error((body && body.error) || "Could not upload artwork");
        }
        return body;
      });
    });
  }

  function propMap(body) {
    var src = body && body.properties;
    var out = {};
    if (!src) return out;
    if (Array.isArray(src)) {
      src.forEach(function (row) {
        if (Array.isArray(row) && row.length >= 2) out[String(row[0])] = row[1];
        else if (row && row.name) out[String(row.name)] = row.value;
      });
      return out;
    }
    if (typeof src === "object") return src;
    return out;
  }

  /* If the custom upload missed, copy the Shopify CDN URL into the print block. Never replace a custom URL. */
  function absorbShopArt(body, files, dest) {
    if (!dest) return;
    var got = propMap(body);
    (files || []).forEach(function (f) {
      var loc = f.loc || "Front";
      var slug = f.slug || locSlug(loc);
      var shop = got["_shopfile_" + slug] || got["artwork_" + slug];
      if (typeof shop !== "string" || !shop) return;
      var url = publicArtUrl(shop);
      if (!url || !/^https?:\/\//i.test(url)) return;
      var key = "_Print | " + loc;
      dest[key] = insertFileUrl(dest[key] || dest["Print | " + loc], url);
      if (dest["Print | " + loc]) delete dest["Print | " + loc];
    });
  }

  function propsForLine(base, line) {
    var out = {};
    Object.keys(base || {}).forEach(function (key) { out[key] = base[key]; });
    if (!out["Blank acknowledgment"]) return out;
    var api = typeof window !== "undefined" ? window.EZINKBlankAck : null;
    if (line && line.closeout && api && api.CLOSEOUT_ACK_TEXT) {
      out["Blank acknowledgment"] = api.CLOSEOUT_ACK_TEXT;
      out._closeout = "1";
    } else if (api && api.ACK_TEXT) {
      out["Blank acknowledgment"] = api.ACK_TEXT;
      delete out._closeout;
    }
    return out;
  }

  function addToCart(form, scope) {
    scope = scope || productRoot(form);
    var lines = sizeLines(scope);
    if (!lines.length) {
      return Promise.reject(new Error("Enter a quantity for at least one size."));
    }
    var art = collectArtwork(form);
    var props = art.props;
    var ackEl = form.querySelector("[data-ezink-blank-ack-prop]");
    if (ackEl && !ackEl.disabled && String(ackEl.value || "").trim()) {
      props["Blank acknowledgment"] = String(ackEl.value).trim();
    }
    var rightsEl = form.querySelector("[data-ezink-art-rights-prop]");
    var rightsApi = typeof window !== "undefined" ? window.EZINKArtRights : null;
    var uploading = (art.files && art.files.length > 0) || (art.locations || []).some(function (row) {
      return !!(row && (row.fileName || row.linkUrl));
    });
    if (uploading) {
      if (rightsApi && typeof rightsApi.requireProduct === "function" && !rightsApi.requireProduct(form)) {
        return Promise.reject(new Error(rightsApi.ACK_MSG || "Check the box to confirm you have the rights to this artwork."));
      }
      var rightsVal = "";
      if (rightsEl && !rightsEl.disabled && String(rightsEl.value || "").trim()) {
        rightsVal = String(rightsEl.value).trim();
      } else if (rightsApi && rightsApi.ACK_TEXT) {
        rightsVal = rightsApi.ACK_TEXT;
      }
      if (rightsVal) props["Artwork rights"] = rightsVal;
    }
    var locRows = art.locations || [];
    props["_Artwork set"] = Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
    var pack = [];
    var prep = Promise.resolve();
    (art.files || []).forEach(function (f) {
      prep = prep.then(function () {
        return uploadArtFile(f.file)
          .then(function (info) {
            var slug = f.slug || locSlug(f.loc);
            var token = artToken(info.url);
            var packed = token.indexOf("/") >= 0 ? token.replace("/", ":") : token;
            if (!packed) throw new Error("Artwork upload did not return a file link");
            props["_artwork_" + slug] = packed;
            var fileUrl = publicArtUrl(info.url);
            pack.push(slug + "=" + packed);
            locRows.forEach(function (row) {
              if (row.slug !== slug) return;
              row.token = packed;
              if (fileUrl) row.fileUrl = fileUrl;
              row.fileName = info.name || f.file.name || row.fileName;
            });
          })
          .catch(function () {
            /* First cart line still attaches the native file. */
          });
      });
    });
    return prep.then(function () {
      stampArt(props, locRows);
      if (pack.length) props["_artfiles"] = pack.join("|").slice(0, 500);
      var qty = 0;
      lines.forEach(function (l) { qty += l.quantity; });
      var pdp = (form && form.querySelector("[data-ezink-art-pdp]")) || document.querySelector("[data-ezink-art-pdp]");
      var decoEach = 0;
      try {
        if (window.EZINKHtv && typeof window.EZINKHtv.extraEachCents === "function") {
          decoEach = Number(window.EZINKHtv.extraEachCents(qty, pdp)) || 0;
        }
      } catch (errDeco) {}
      if (decoEach > 0) {
        props["_deco_each"] = String(decoEach);
        props["_set_qty"] = String(qty);
      }
      var slim = cartArtProps(props);
      var chain = Promise.resolve();
      var first = true;
      lines.forEach(function (line) {
        chain = chain.then(function () {
          var lineProps = propsForLine(slim, line);
          if (first && art.files && art.files.length) {
            first = false;
            return postOneFd(line.id, line.quantity, lineProps, art.files).then(function (body) {
              absorbShopArt(body, art.files, slim);
              return body;
            });
          }
          first = false;
          return postOne({ id: line.id, quantity: line.quantity, properties: lineProps });
        });
      });
      return chain.then(function () {
        var extra = window.EZINKHtv && window.EZINKHtv.cartLines ? window.EZINKHtv.cartLines(qty, pdp) : [];
        var extraChain = Promise.resolve();
        var setId = props["_Artwork set"];
        (extra || []).forEach(function (row) {
          extraChain = extraChain.then(function () {
            var extraProps = row.properties || {};
            if (setId) extraProps["_Artwork set"] = setId;
            extraProps["_set_qty"] = String(qty);
            return postOne({ id: row.id, quantity: row.quantity, properties: extraProps });
          });
        });
        return extraChain;
      });
    });
  }

  function productRoot(el) {
    return (el && el.closest && (el.closest("[data-section-type='product']") || el.closest(".product-template__container"))) || document;
  }

  function armForm(form, root) {
    if (!form || form.getAttribute("data-ezink-size-qty-armed") === "1") return;
    form.setAttribute("data-ezink-size-qty-armed", "1");
    var idSel = form.querySelector('select[name="id"], input[name="id"]');
    if (idSel) idSel.removeAttribute("name");
    var qty = form.querySelector('[name="quantity"]');
    if (qty && form.querySelector("[data-ezink-size-qty]")) qty.removeAttribute("name");
    root.querySelectorAll("[data-add-to-cart]").forEach(function (btn) {
      btn.setAttribute("type", "button");
      btn.removeAttribute("name");
    });
    form.addEventListener(
      "submit",
      function (evt) {
        evt.preventDefault();
        evt.stopPropagation();
        if (evt.stopImmediatePropagation) evt.stopImmediatePropagation();
        run(form, root);
      },
      true
    );
    if (window.jQuery) {
      jQuery(form).off("submit");
      [0, 300, 1200, 3000].forEach(function (ms) {
        setTimeout(function () { jQuery(form).off("submit"); }, ms);
      });
    }
  }

  function run(form, root) {
    if (!form || form.getAttribute("data-ezink-adding") === "1") return;
    if (window.EZINKArtRights && typeof window.EZINKArtRights.requireProduct === "function") {
      if (!window.EZINKArtRights.requireProduct(form)) return;
    }
    form.setAttribute("data-ezink-adding", "1");
    addToCart(form, root)
      .then(function () {
        window.location.href = "/cart";
      })
      .catch(function (err) {
        form.removeAttribute("data-ezink-adding");
        window.alert((err && err.message) || "Could not add to cart");
      });
  }

  if (typeof document !== "undefined") document.addEventListener(
    "click",
    function (evt) {
      var btn = evt.target && evt.target.closest && evt.target.closest("[data-add-to-cart]");
      if (!btn) return;
      var form = btn.form || (btn.closest && btn.closest("form"));
      if (!form || !form.querySelector("[data-ezink-size-qty]")) return;
      evt.preventDefault();
      evt.stopPropagation();
      if (evt.stopImmediatePropagation) evt.stopImmediatePropagation();
      var root = productRoot(form);
      armForm(form, root);
      run(form, root);
    },
    true
  );

  function boot() {
    document.querySelectorAll("[data-ezink-size-qty]").forEach(function (wrap) {
      var root = productRoot(wrap);
      var form = wrap.closest("form") || (root.querySelector && (root.querySelector("[data-product-form]") || root.querySelector("form.product-form")));
      if (form) armForm(form, root);
      if (root && root.setAttribute) root.setAttribute("data-ajax-enabled", "false");
    });
  }

  var MAX_CART_QTY = 1500;

  /* Sheet lines are one print per piece. Extra placement is (locations - 1) per piece.
     feeEach is that multiplier, taken from the location list when the cart rendered. */
  function planArtworkQtyUpdates(sets) {
    var updates = {};
    (sets || []).forEach(function (set) {
      var feeEach = parseInt(set && set.feeEach, 10) || 0;
      if (feeEach < 0) feeEach = 0;
      var total = 0;
      var seen = {};
      (set.lines || []).forEach(function (line) {
        if (!line || line.role !== "garment" || !line.key) return;
        if (seen[line.key]) return;
        seen[line.key] = true;
        var n = line.next != null ? line.next : line.quantity;
        n = parseInt(n, 10);
        if (isNaN(n) || n < 0) n = 0;
        if (n > MAX_CART_QTY) n = MAX_CART_QTY;
        total += n;
        if (n !== (parseInt(line.quantity, 10) || 0)) updates[line.key] = n;
      });
      (set.lines || []).forEach(function (line) {
        if (!line || line.role !== "deco" || !line.key) return;
        var next;
        if (line.kind === "fee") {
          if (feeEach < 1) return;
          next = total * feeEach;
        } else {
          next = total;
        }
        if ((parseInt(line.quantity, 10) || 0) !== next) updates[line.key] = next;
      });
    });
    return updates;
  }

  function artworkProps(src) {
    var out = {};
    if (!src) return out;
    if (Array.isArray(src)) {
      src.forEach(function (row) {
        if (Array.isArray(row) && row.length >= 2) out[String(row[0])] = row[1];
        else if (row && row.name) out[String(row.name)] = row.value;
      });
    } else {
      Object.keys(src).forEach(function (k) {
        if (src[k] == null) return;
        out[k] = src[k];
      });
    }
    Object.keys(out).forEach(function (k) {
      if (typeof out[k] !== "string") out[k] = String(out[k]);
    });
    return out;
  }

  function isDecorationItem(item) {
    var props = (item && item.properties) || {};
    if (props._print_adjust || props["_print_adjust"]) return true;
    var handle = String((item && item.handle) || "");
    if (handle === "ezink-htv-decoration" || handle === "print-spec-adjustment") return true;
    if (String((item && item.product_type) || "") === "Decoration") return true;
    if (String((item && item.product_title) || "") === "Specification difference") return true;
    return false;
  }

  function planCheckoutOrder(items) {
    items = items || [];
    var groups = [];
    var byKey = {};
    items.forEach(function (item, index) {
      if (!item) return;
      var props = item.properties || {};
      var setId = props["_Artwork set"] || "";
      var key = setId || ("line:" + (item.key || index));
      var group = byKey[key];
      if (!group) {
        group = { key: key, garments: [], decos: [], first: index, anchor: null };
        byKey[key] = group;
        groups.push(group);
      }
      if (isDecorationItem(item)) group.decos.push(item);
      else {
        group.garments.push(item);
        if (group.anchor == null) group.anchor = index;
      }
    });
    groups.sort(function (a, b) {
      return (a.anchor != null ? a.anchor : a.first) - (b.anchor != null ? b.anchor : b.first);
    });
    var desired = [];
    groups.forEach(function (group) {
      group.garments.forEach(function (item) { desired.push(item); });
      group.decos.forEach(function (item) { desired.push(item); });
    });
    return desired;
  }

  function checkoutOrderMatches(items, desired) {
    items = items || [];
    desired = desired || [];
    if (items.length !== desired.length) return false;
    for (var i = 0; i < items.length; i++) {
      if ((items[i] && items[i].key) !== (desired[i] && desired[i].key)) return false;
    }
    return true;
  }

  function setLabelForItems(items) {
    var labels = {};
    var seen = {};
    var n = 0;
    planCheckoutOrder(items).forEach(function (item) {
      var setId = ((item && item.properties) || {})["_Artwork set"] || "";
      if (!setId || !item.key) return;
      if (!seen[setId]) {
        n += 1;
        seen[setId] = "[SET " + n + "]";
      }
      labels[item.key] = seen[setId];
    });
    return labels;
  }

  function isShopFileKey(key) {
    return /^artwork_[a-z0-9_]+$/i.test(key);
  }

  function checkoutArtKey(key) {
    if (!key || key.charAt(0) === "_") return key;
    if (key === "Set" || key === "Print") return key;
    if (
      key === "Artwork locations" ||
      key === "Decoration" ||
      key === "Location" ||
      key === "Print size" ||
      key === "Print type" ||
      key.indexOf("Print | ") === 0 ||
      key.indexOf("Print size ") === 0 ||
      key.indexOf("Print type ") === 0 ||
      key.indexOf("Print type — ") === 0 ||
      key.indexOf("Size — ") === 0 ||
      key.indexOf("Artwork notes") === 0 ||
      key.indexOf("Artwork link") === 0 ||
      key.indexOf("Artwork file") === 0 ||
      key.indexOf("Art file ") === 0 ||
      key.indexOf("Art name") === 0 ||
      key.indexOf("Transfer ") === 0 ||
      key.indexOf("Artwork — ") === 0
    ) return "_" + key;
    return key;
  }

  function hasPublicArtDump(props) {
    return Object.keys(props || {}).some(function (key) {
      if (props[key] == null || props[key] === "") return false;
      return checkoutArtKey(key) !== key || isShopFileKey(key);
    });
  }

  function shortArtLine(props) {
    props = props || {};
    if (props._print_adjust || props["_print_adjust"]) return "";
    if (!isDecorationLine(props)) {
      var rows = locationsFromProps(props);
      if (rows.length) {
        return rows.map(function (row) {
          var bits = [row.loc];
          if (row.sizeLabel) bits.push(row.sizeLabel);
          if (row.typeLabel) bits.push(row.typeLabel);
          return bits.join(" · ");
        }).join("; ");
      }
    }
    var loc = artProp(props, "Location");
    if (loc === "Extra placement") return "Extra location";
    var size = artProp(props, "Print size");
    var type = artProp(props, "Print type");
    var bits = [];
    if (loc) bits.push(loc);
    if (size) bits.push(size);
    if (type) bits.push(type);
    return bits.join(" · ");
  }

  function isPreviewKey(key) {
    return key === "Preview" || key.indexOf("Preview ") === 0;
  }

  function previewLinksFor(item, items) {
    var props = (item && item.properties) || {};
    if (!isDecorationLine(props)) return {};
    var loc = artProp(props, "Location");
    if (!loc || loc === "Extra placement") return {};
    var setId = String(props["_Artwork set"] || "");
    var names = String(loc).split(/\s+\+\s+/).map(function (part) { return part.replace(/\s+/g, " ").trim(); }).filter(Boolean);
    var links = [];
    names.forEach(function (name) {
      var url = "";
      (items || []).forEach(function (other) {
        if (!other || other === item || other.key === item.key) return;
        var otherProps = other.properties || {};
        if (setId && String(otherProps["_Artwork set"] || "") !== setId) return;
        if (isDecorationLine(otherProps)) return;
        locationsFromProps(otherProps).forEach(function (row) {
          if (!sameLoc(row.loc, name)) return;
          var candidate = row.fileUrl || row.linkUrl || "";
          if (!candidate) return;
          if (!url || /custom\.ez-ink\.com\/shopify\/artwork\//i.test(candidate)) url = candidate;
        });
      });
      if (url) links.push({ loc: name, url: url });
    });
    var out = {};
    if (links.length === 1) out.Preview = links[0].url;
    else links.forEach(function (link) { out["Preview " + link.loc] = link.url; });
    return out;
  }

  function loosePreview(props) {
    var deco = isDecorationLine(props);
    return Object.keys(props || {}).some(function (key) {
      if (!isPreviewKey(key)) return false;
      var val = String(props[key] || "");
      if (!val) return false;
      if (!deco) return true;
      return !/cdn\.shopify\.com\/s\/files\//i.test(val);
    });
  }

  function previewFilePlan(items) {
    var plan = {};
    (items || []).forEach(function (item) {
      if (!item || !item.key) return;
      var links = previewLinksFor(item, items);
      var files = [];
      Object.keys(links).forEach(function (prop) {
        var url = String(links[prop] || "");
        if (!/custom\.ez-ink\.com\/shopify\/artwork\//i.test(url)) return;
        files.push({ prop: prop, url: url, filename: fileNameFromUrl(url) || "artwork" });
      });
      if (files.length) plan[item.key] = files;
    });
    return plan;
  }

  function shopPreviewFile(value) {
    return /cdn\.shopify\.com\/s\/files\//i.test(String(value || ""));
  }

  function previewFilesReady(items, plan) {
    return (items || []).every(function (item) {
      if (!item) return true;
      var want = (plan && plan[item.key]) || [];
      var props = item.properties || {};
      var present = Object.keys(props).filter(function (key) {
        return isPreviewKey(key) && props[key];
      });
      if (!want.length) return present.length === 0;
      if (present.length !== want.length) return false;
      return want.every(function (file) { return shopPreviewFile(props[file.prop]); });
    });
  }

  function propertiesWithSetLabel(item, label, items) {
    var src = artworkProps(item && item.properties);
    var staged = {};
    Object.keys(src).forEach(function (key) {
      if (src[key] == null || src[key] === "" || key === "Set" || key === "Print") return;
      if (isPreviewKey(key)) return;
      if (isShopFileKey(key)) {
        var shopKey = "_shopfile_" + key.slice("artwork_".length);
        var url = publicArtUrl(src[key]);
        staged[shopKey] = /^https?:\/\//i.test(url) ? url : String(src[key]);
        return;
      }
      var dest = checkoutArtKey(key);
      if (staged[dest] == null) staged[dest] = String(src[key]);
      else if (dest.indexOf("_Print | ") === 0) {
        String(src[key]).split(/\s+/).forEach(function (part) {
          var match = String(part || "").match(/https?:\/\/\S+/i);
          if (match) staged[dest] = insertFileUrl(staged[dest], match[0].replace(/[),.;]+$/, ""));
        });
      }
    });
    Object.keys(staged).forEach(function (key) {
      if (key.indexOf("_shopfile_") !== 0) return;
      var url = staged[key];
      if (!/^https?:\/\//i.test(String(url))) return;
      var slug = key.slice("_shopfile_".length);
      Object.keys(staged).forEach(function (blockKey) {
        if (blockKey.indexOf("_Print | ") !== 0) return;
        if (locSlug(blockKey.slice("_Print | ".length)) !== slug) return;
        staged[blockKey] = insertFileUrl(staged[blockKey], url);
      });
    });
    var print = shortArtLine(staged);
    var props = {};
    if (label) props.Set = label;
    if (print) props.Print = print;
    Object.keys(staged).forEach(function (key) {
      if (staged[key] == null || staged[key] === "") return;
      props[key] = staged[key];
    });
    return props;
  }

  function artPayloadKey(key) {
    if (!key) return false;
    if (key.indexOf("_Print | ") === 0 || key.indexOf("Print | ") === 0) return true;
    if (key.indexOf("_artwork_") === 0 || key.indexOf("_shopfile_") === 0) return true;
    if (key.indexOf("_artlink_") === 0 || key.indexOf("_artname_") === 0) return true;
    if (key === "_artfiles" || key === "_Artwork locations" || key === "Artwork locations") return true;
    return isShopFileKey(key);
  }

  function decorationDetailKey(key) {
    return key === "_Location" || key === "_Print size" || key === "_Print type" || key === "_Decoration" ||
      key === "Location" || key === "Print size" || key === "Print type" || key === "Decoration";
  }

  function orderFacingProps(item, items) {
    var labels = setLabelForItems(items);
    var props = propertiesWithSetLabel(item, labels[item.key] || "", items);
    var deco = isDecorationLine((item && item.properties) || {});
    Object.keys(props).forEach(function (key) {
      if (artPayloadKey(key)) delete props[key];
      if (key === "_Artwork set" || key === "_deco_each" || key === "_set_qty") delete props[key];
      if (deco && decorationDetailKey(key)) delete props[key];
    });
    if (!deco) return props;
    var links = previewLinksFor(item, items);
    var names = Object.keys(links);
    if (!names.length) return props;
    var ordered = {};
    if (props.Set) ordered.Set = props.Set;
    if (props.Print) ordered.Print = props.Print;
    if (names.length === 1) {
      ordered.File = fileNameFromUrl(links[names[0]]) || "artwork";
      ordered.Artwork = links[names[0]];
    } else {
      names.forEach(function (name) {
        var loc = name.indexOf("Preview ") === 0 ? name.slice("Preview ".length) : name;
        ordered["File " + loc] = fileNameFromUrl(links[name]) || "artwork";
        ordered["Artwork " + loc] = links[name];
      });
    }
    Object.keys(props).forEach(function (key) {
      if (key === "Set" || key === "Print" || ordered[key] != null) return;
      ordered[key] = props[key];
    });
    return ordered;
  }

  function orderPropsDiffer(item, items) {
    var next = orderFacingProps(item, items);
    var prev = (item && item.properties) || {};
    var keys = {};
    Object.keys(prev).forEach(function (key) {
      if (prev[key] != null && prev[key] !== "" && !isPreviewKey(key)) keys[key] = true;
    });
    Object.keys(next).forEach(function (key) {
      if (next[key] != null && next[key] !== "") keys[key] = true;
    });
    return Object.keys(keys).some(function (key) {
      return String(prev[key] || "") !== String(next[key] || "");
    });
  }

  function withOrderProps(items) {
    return (items || []).map(function (item) {
      var copy = {};
      Object.keys(item || {}).forEach(function (key) { copy[key] = item[key]; });
      copy.properties = orderFacingProps(item, items);
      return copy;
    });
  }

  function setLabelNeedsWrite(item, label, items) {
    var props = (item && item.properties) || {};
    var keys = Object.keys(props).filter(function (key) {
      return props[key] != null && props[key] !== "";
    });
    var have = String(props.Set || "");
    var print = shortArtLine(props);
    var dump = hasPublicArtDump(props);
    if (!label) {
      if (have !== "") return true;
      if (dump) return true;
      if (loosePreview(props)) return true;
      if (print && String(props.Print || "") !== print) return true;
      if (print && keys[0] !== "Print") return true;
      return false;
    }
    if (have !== label || keys[0] !== "Set") return true;
    if (dump) return true;
    if (loosePreview(props)) return true;
    if (print) {
      if (String(props.Print || "") !== print) return true;
      if (keys[1] !== "Print") return true;
    } else if (props.Print) return true;
    return false;
  }

  function setLabelJobs(items) {
    var labels = setLabelForItems(items);
    var jobs = [];
    (items || []).forEach(function (item) {
      if (!item || !item.key) return;
      var want = labels[item.key] || "";
      if (!setLabelNeedsWrite(item, want, items)) return;
      jobs.push({
        id: item.key,
        quantity: parseInt(item.quantity, 10) || 1,
        properties: propertiesWithSetLabel(item, want, items)
      });
    });
    return jobs;
  }

  function itemsWithSetLabels(items) {
    var labels = setLabelForItems(items);
    return (items || []).map(function (item) {
      if (!item) return item;
      var want = labels[item.key] || "";
      if (!setLabelNeedsWrite(item, want, items)) return item;
      var copy = {};
      Object.keys(item).forEach(function (k) { copy[k] = item[k]; });
      copy.properties = propertiesWithSetLabel(item, want, items);
      return copy;
    });
  }

  function cartJson(res) {
    return res.text().then(function (text) {
      var data = {};
      if (text) {
        try { data = JSON.parse(text); } catch (err) { data = {}; }
      }
      if (!res.ok) {
        throw new Error((data && (data.description || data.message)) || "Could not update the cart");
      }
      return data;
    });
  }

  function postCart(url, body) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify(body || {})
    }).then(cartJson);
  }

  function linePayload(item) {
    var props = {};
    var src = (item && item.properties) || {};
    Object.keys(src).forEach(function (k) {
      if (src[k] == null || src[k] === "" || isPreviewKey(k)) return;
      props[k] = String(src[k]);
    });
    var body = {
      id: Number(item.variant_id || item.id),
      quantity: Number(item.quantity) || 1,
      properties: props
    };
    var plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
    if (plan && plan.id) body.selling_plan = plan.id;
    return body;
  }

  function loadPreviewBlobs(plan) {
    var jobs = [];
    Object.keys(plan || {}).forEach(function (key) {
      (plan[key] || []).forEach(function (spec) {
        jobs.push(fetch(spec.url, { mode: "cors", credentials: "omit" }).then(function (res) {
          if (!res.ok) throw new Error("Could not load the artwork preview");
          return res.blob().then(function (blob) {
            return { key: key, prop: spec.prop, blob: blob, filename: spec.filename || "artwork" };
          });
        }).then(function (row) { return row; }, function () { return null; }));
      });
    });
    return Promise.all(jobs).then(function (rows) {
      var byKey = {};
      (rows || []).forEach(function (row) {
        if (!row) return;
        if (!byKey[row.key]) byKey[row.key] = [];
        byKey[row.key].push(row);
      });
      return byKey;
    });
  }

  function addCartLine(item, files) {
    if (!files || !files.length) return postCart("/cart/add.js", linePayload(item));
    var fd = new FormData();
    fd.append("id", String(item.variant_id || item.id));
    fd.append("quantity", String(item.quantity || 1));
    var props = (item && item.properties) || {};
    Object.keys(props).forEach(function (key) {
      if (props[key] == null || props[key] === "" || isPreviewKey(key)) return;
      fd.append("properties[" + key + "]", String(props[key]));
    });
    var plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
    if (plan && plan.id) fd.append("selling_plan", String(plan.id));
    files.forEach(function (file) {
      fd.append("properties[" + file.prop + "]", file.blob, file.filename || "artwork");
    });
    return fetch("/cart/add.js", {
      method: "POST",
      body: fd,
      credentials: "same-origin",
      headers: { Accept: "application/json" }
    }).then(cartJson);
  }

  function addLinesOldestFirst(lines, filesByKey) {
    var chain = Promise.resolve();
    for (var i = lines.length - 1; i >= 0; i--) {
      (function (item) {
        chain = chain.then(function () {
          return addCartLine(item, filesByKey && filesByKey[item.key]);
        });
      })(lines[i]);
    }
    return chain;
  }

  function applyLabelJobs(jobs) {
    var chain = Promise.resolve();
    (jobs || []).forEach(function (job) {
      chain = chain.then(function () { return postCart("/cart/change.js", job); });
    });
    return chain;
  }

  function rebuildCart(cart, desired, filesByKey) {
    var items = (cart && cart.items) || [];
    var snapshot = { items: items, note: cart.note || "", attributes: cart.attributes || {} };
    return postCart("/cart/clear.js", {}).then(function () {
      return addLinesOldestFirst(desired, filesByKey);
    }).then(function () {
      return postCart("/cart/update.js", { note: snapshot.note, attributes: snapshot.attributes });
    }).catch(function (err) {
      return postCart("/cart/clear.js", {}).then(function () {
        return addLinesOldestFirst(snapshot.items);
      }).then(function () {
        return postCart("/cart/update.js", { note: snapshot.note, attributes: snapshot.attributes });
      }).then(function () { throw err; }, function () { throw err; });
    });
  }

  function reorderCartForCheckout() {
    return fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (res) { return cartJson(res); })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        var plan = previewFilePlan(items);
        var facing = withOrderProps(items);
        var desired = planCheckoutOrder(facing);
        var labelJobs = setLabelJobs(items);
        var orderOk = checkoutOrderMatches(items, desired);
        var filesReady = previewFilesReady(items, plan);
        var facingDirty = items.some(function (item) { return orderPropsDiffer(item, items); });
        var needUpload = Object.keys(plan).length > 0 && (!filesReady || !orderOk || labelJobs.length > 0 || facingDirty);
        var pending = needUpload ? loadPreviewBlobs(plan) : Promise.resolve({});
        return pending.then(function (filesByKey) {
          var uploading = Object.keys(filesByKey || {}).length > 0;
          if (orderOk && filesReady && !labelJobs.length && !facingDirty) return cart;
          if (!uploading && orderOk && !facingDirty) return applyLabelJobs(labelJobs).then(function () { return cart; });
          if (!uploading && orderOk && facingDirty && !Object.keys(plan).length) {
            var facingJobs = items.filter(function (item) { return orderPropsDiffer(item, items); }).map(function (item) {
              return {
                id: item.key,
                quantity: parseInt(item.quantity, 10) || 1,
                properties: orderFacingProps(item, items)
              };
            });
            return applyLabelJobs(facingJobs).then(function () { return cart; });
          }
          return rebuildCart(cart, desired, filesByKey);
        });
      });
  }

  function artworkSetQtyJobs(items, totalsBySet) {
    var jobs = [];
    (items || []).forEach(function (item) {
      if (!item || !item.key || !(parseInt(item.quantity, 10) > 0)) return;
      var props = artworkProps(item.properties);
      var setId = props["_Artwork set"];
      if (!setId || !totalsBySet || totalsBySet[setId] == null) return;
      var total = parseInt(totalsBySet[setId], 10) || 0;
      if (total < 1) return;
      if (String(props["_set_qty"] || "") === String(total)) return;
      props["_set_qty"] = String(total);
      Object.keys(props).forEach(function (key) {
        if (isPreviewKey(key)) delete props[key];
      });
      jobs.push({ id: item.key, quantity: parseInt(item.quantity, 10), properties: props });
    });
    return jobs;
  }

  /* A quantity-only cart update cannot move A4L/100 onto A4L/50. Rebuild the
     sheet from the distinct garment count so the price band matches that count. */
  function decorationLoc(props) {
    return String(artProp(props, "Location") || "").replace(/\s+/g, " ").trim();
  }

  function isHtvDecorationItem(item) {
    if (!item) return false;
    var props = artworkProps(item.properties);
    if (props._print_adjust || props["_print_adjust"]) return false;
    var handle = String(item.handle || "");
    if (handle === "print-spec-adjustment") return false;
    if (String(item.product_title || "") === "Specification difference") return false;
    if (handle === "ezink-htv-decoration") return true;
    if (String(item.product_type || "") === "Decoration" && decorationLoc(props)) return true;
    return isDecorationLine(props);
  }

  function specsForDecoration(garments, decos) {
    var rows = garments.length ? locationsFromProps(artworkProps(garments[0].properties)) : [];
    var specs = decorationSpecs(rows);
    if (rows.length && specs.length === rows.length) return specs;
    var fromDeco = [];
    (decos || []).forEach(function (item) {
      var props = artworkProps(item.properties);
      var loc = decorationLoc(props);
      if (!loc || loc === "Extra placement") return;
      var sizeLabel = artProp(props, "Print size");
      if (!sizeLabel) return;
      fromDeco.push({ loc: loc, sizeLabel: sizeLabel, typeLabel: artProp(props, "Print type") });
    });
    var decoSpecs = decorationSpecs(fromDeco);
    if (fromDeco.length && decoSpecs.length === fromDeco.length) return decoSpecs;
    return [];
  }

  function planDecorationRebuild(items, buildLines) {
    var groups = {};
    var order = [];
    (items || []).forEach(function (item) {
      if (!item) return;
      var props = artworkProps(item.properties);
      var setId = props["_Artwork set"] || "";
      if (!setId) return;
      if (!groups[setId]) {
        groups[setId] = { id: setId, garments: [], decos: [], seen: {} };
        order.push(setId);
      }
      var group = groups[setId];
      if (isHtvDecorationItem(item)) {
        group.decos.push(item);
        return;
      }
      if (isDecorationItem(item)) return;
      if (!item.key || group.seen[item.key]) return;
      group.seen[item.key] = true;
      group.garments.push(item);
    });
    var jobs = [];
    var error = "";
    order.forEach(function (setId) {
      if (error) return;
      var group = groups[setId];
      if (!group.decos.length) return;
      if (lineSkipsPrintCharge(group.garments)) return;
      var qty = 0;
      group.garments.forEach(function (item) {
        qty += parseInt(item.quantity, 10) || 0;
      });
      if (qty < 1) {
        jobs.push({
          setId: setId,
          removeKeys: group.decos.map(function (item) { return item.key; }).filter(Boolean),
          addLines: []
        });
        return;
      }
      var specs = specsForDecoration(group.garments, group.decos);
      if (!specs.length || typeof buildLines !== "function") {
        error = "Could not recalculate the print charge.";
        return;
      }
      var built = buildLines(qty, specs) || [];
      if (!built.length) {
        error = "Could not recalculate the print charge.";
        return;
      }
      var used = {};
      var removeKeys = [];
      var addLines = [];
      built.forEach(function (line) {
        var loc = decorationLoc(line.properties);
        var match = null;
        group.decos.forEach(function (item) {
          if (match || used[item.key]) return;
          if (decorationLoc(artworkProps(item.properties)) === loc) match = item;
        });
        var same = match &&
          Number(match.variant_id || match.id) === Number(line.id) &&
          (parseInt(match.quantity, 10) || 0) === (parseInt(line.quantity, 10) || 0);
        if (same) {
          used[match.key] = true;
          return;
        }
        if (match && match.key) {
          used[match.key] = true;
          removeKeys.push(match.key);
        }
        var props = artworkProps(match && match.properties);
        Object.keys(props).forEach(function (key) {
          if (isPreviewKey(key)) delete props[key];
        });
        var fresh = artworkProps(line.properties);
        Object.keys(fresh).forEach(function (key) { props[key] = fresh[key]; });
        props["_Artwork set"] = setId;
        props["_set_qty"] = String(qty);
        addLines.push({ id: line.id, quantity: line.quantity, properties: props });
      });
      group.decos.forEach(function (item) {
        if (item && item.key && !used[item.key]) removeKeys.push(item.key);
      });
      if (removeKeys.length || addLines.length) {
        jobs.push({ setId: setId, removeKeys: removeKeys, addLines: addLines });
      }
    });
    if (error) return { error: error, jobs: [] };
    return { jobs: jobs };
  }

  function htvCartLines(qty, specs) {
    if (typeof window === "undefined" || !window.EZINKHtv || typeof window.EZINKHtv.cartLines !== "function") return null;
    return window.EZINKHtv.cartLines(qty, specs);
  }

  function applyDecorationJobs(jobs, cart) {
    var byKey = {};
    ((cart && cart.items) || []).forEach(function (item) {
      if (item && item.key) byKey[item.key] = item;
    });
    var chain = Promise.resolve();
    (jobs || []).forEach(function (job) {
      chain = chain.then(function () {
        var removed = [];
        var added = [];
        var step = Promise.resolve();
        (job.removeKeys || []).forEach(function (key) {
          step = step.then(function () {
            return postCart("/cart/change.js", { id: key, quantity: 0 }).then(function () {
              if (byKey[key]) removed.push(byKey[key]);
            });
          });
        });
        (job.addLines || []).forEach(function (line) {
          step = step.then(function () {
            return postCart("/cart/add.js", line).then(function (body) {
              if (body && body.key) added.push(body.key);
            });
          });
        });
        return step.catch(function (err) {
          var undo = Promise.resolve();
          added.forEach(function (key) {
            undo = undo.then(function () {
              return postCart("/cart/change.js", { id: key, quantity: 0 }).catch(function () { return null; });
            });
          });
          removed.forEach(function (item) {
            undo = undo.then(function () {
              return postCart("/cart/add.js", linePayload(item)).catch(function () { return null; });
            });
          });
          return undo.then(function () { throw err; });
        });
      });
    });
    return chain;
  }

  function alignDecorationLines() {
    return fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (res) { return cartJson(res); })
      .then(function (cart) {
        var plan = planDecorationRebuild((cart && cart.items) || [], htvCartLines);
        if (plan.error) throw new Error(plan.error);
        if (!plan.jobs.length) return false;
        return applyDecorationJobs(plan.jobs, cart).then(function () { return true; });
      });
  }

  function bootCartQtySync() {
    var form = document.querySelector("form[data-ezink-cart-artwork]");
    if (!form || form.getAttribute("data-ezink-qty-sync") === "1") return;
    form.setAttribute("data-ezink-qty-sync", "1");
    var flight = null;
    var dest = "";

    function readSets() {
      var sets = [];
      form.querySelectorAll("section.ezink-cart-set[data-art-set]").forEach(function (section) {
        var lines = [];
        section.querySelectorAll("[data-cart-item][data-cart-item-key]").forEach(function (row) {
          var role = row.getAttribute("data-ezink-line-role") || "";
          var server = parseInt(row.getAttribute("data-cart-item-quantity"), 10) || 0;
          var next = server;
          if (role === "garment") {
            var input = row.querySelector("[data-quantity-input-desktop]");
            if (input) {
              next = parseInt(input.value, 10);
              if (isNaN(next) || input.value === "") next = 0;
              if (next < 0) next = 0;
              if (next > MAX_CART_QTY) next = MAX_CART_QTY;
              input.value = String(next);
            }
          }
          lines.push({
            key: row.getAttribute("data-cart-item-key"),
            role: role,
            kind: row.getAttribute("data-ezink-deco-kind") || "",
            quantity: server,
            next: next
          });
        });
        sets.push({
          id: section.getAttribute("data-art-set") || "",
          feeEach: parseInt(section.getAttribute("data-ezink-fee-each"), 10) || 0,
          lines: lines
        });
      });
      return sets;
    }

    function applyHidden(updates) {
      form.querySelectorAll("[data-cart-item][data-cart-item-key]").forEach(function (row) {
        var key = row.getAttribute("data-cart-item-key");
        if (!Object.prototype.hasOwnProperty.call(updates, key)) return;
        var input = row.querySelector("[data-quantity-input]");
        if (input) input.value = String(updates[key]);
      });
    }

    function setTotals(sets) {
      var totals = {};
      (sets || []).forEach(function (set) {
        if (!set.id) return;
        var total = 0;
        var seen = {};
        (set.lines || []).forEach(function (line) {
          if (line.role !== "garment") return;
          if (line.key) {
            if (seen[line.key]) return;
            seen[line.key] = true;
          }
          var n = parseInt(line.next, 10);
          if (isNaN(n) || n < 0) n = 0;
          total += n;
        });
        totals[set.id] = total;
      });
      return totals;
    }

    function patchSetQty(totals) {
      var ids = Object.keys(totals || {});
      if (!ids.length) return Promise.resolve();
      return fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
        .then(function (res) { return res.json(); })
        .then(function (body) {
          var jobs = artworkSetQtyJobs(body && body.items, totals);
          var chain = Promise.resolve();
          jobs.forEach(function (job) {
            chain = chain.then(function () {
              return fetch("/cart/change.js", {
                method: "POST",
                headers: { "Content-Type": "application/json", Accept: "application/json" },
                credentials: "same-origin",
                body: JSON.stringify(job)
              }).then(function () { return null; }, function () { return null; });
            });
          });
          return chain;
        })
        .catch(function () { return null; });
    }

    function goCheckout() {
      alignNext().then(function () {
        return reorderCartForCheckout();
      }).then(function () {
        window.location.href = "/checkout";
      }).catch(function (err) {
        flight = null;
        dest = "";
        form.removeAttribute("aria-busy");
        var button = form.querySelector("[name='checkout']");
        if (button) button.disabled = false;
        window.alert((err && err.message) || "Could not arrange the cart for checkout.");
      });
    }

    function finish() {
      if (dest === "checkout") goCheckout();
      else window.location.reload();
    }

    function startSync(updates, next) {
      if (next === "checkout") dest = "checkout";
      else if (!dest) dest = "reload";
      applyHidden(updates);
      var totals = setTotals(readSets());
      if (flight) return flight;
      var button = form.querySelector("[name='checkout']");
      if (button) button.disabled = true;
      form.setAttribute("aria-busy", "true");
      var payload = { updates: updates };
      var note = form.querySelector("[name='note']");
      if (note && note.value) payload.note = note.value;
      flight = fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        credentials: "same-origin",
        body: JSON.stringify(payload)
      }).then(function (res) {
        return res.json().then(function (body) {
          if (!res.ok) {
            var msg = (body && (body.description || body.message)) || "Could not update the artwork count";
            throw new Error(msg);
          }
          return body;
        });
      }).then(function () { return patchSetQty(totals); })
        .then(function () { return alignNext(); })
        .then(finish).catch(function (err) {
        flight = null;
        dest = "";
        form.removeAttribute("aria-busy");
        if (button) button.disabled = false;
        try { sessionStorage.removeItem("ezinkCartQtySync"); } catch (errClear) {}
        window.alert((err && err.message) || "Could not update the artwork count.");
      });
      return flight;
    }

    function updatesFromForm() {
      return planArtworkQtyUpdates(readSets());
    }

    document.addEventListener("change", function (evt) {
      var input = evt.target;
      if (!input || !input.closest || !form.contains(input)) return;
      if (!input.hasAttribute("data-quantity-input-desktop")) return;
      var updates = updatesFromForm();
      if (!Object.keys(updates).length) return;
      try { sessionStorage.removeItem("ezinkCartQtySync"); } catch (errStore) {}
      startSync(updates, "reload");
    }, true);

    document.addEventListener("submit", function (evt) {
      if (evt.target !== form) return;
      var updates = updatesFromForm();
      if (!Object.keys(updates).length && !flight) return;
      evt.preventDefault();
      evt.stopPropagation();
      if (!Object.keys(updates).length) {
        dest = "checkout";
        return;
      }
      startSync(updates, "checkout");
    }, true);

    document.addEventListener("submit", function (evt) {
      if (evt.target !== form || evt.defaultPrevented) return;
      var submitter = evt.submitter;
      if (submitter && submitter.getAttribute("name") && submitter.getAttribute("name") !== "checkout") return;
      evt.preventDefault();
      goCheckout();
    });

    var alignChain = Promise.resolve();
    function alignNext() {
      var run = alignChain.then(function () { return alignDecorationLines(); });
      alignChain = run.then(function () { return null; }, function () { return null; });
      return run;
    }

    var initial = updatesFromForm();
    var initialKeys = Object.keys(initial);
    if (initialKeys.length) {
      var sig = "";
      try { sig = JSON.stringify(initial); } catch (errSig) { sig = initialKeys.join(","); }
      var seenSig = "";
      try { seenSig = sessionStorage.getItem("ezinkCartQtySync") || ""; } catch (errSeen) {}
      if (seenSig !== sig) {
        try { sessionStorage.setItem("ezinkCartQtySync", sig); } catch (errSet) {}
        startSync(initial, "reload");
        return "reload";
      }
    }
    /* ezinkCartQtySync records quantity edits only. A wrong price band has no quantity edit, so it must still rebuild. */
    return alignNext().then(function (changed) {
      if (changed) {
        window.location.reload();
        return "reload";
      }
      return "";
    }).catch(function (err) {
      try { sessionStorage.removeItem("ezinkCartQtySync"); } catch (errClear) {}
      window.alert((err && err.message) || "Could not update the artwork count.");
      return "";
    });
  }

  var LOC_CHOICES = ["Front", "Back", "Left chest", "Right chest", "Left sleeve", "Right sleeve", "Nape", "Other"];

  function isPromotionalItem(item) {
    return String((item && item.product_type) || "") === "Promotional";
  }

  function lineSkipsPrintCharge(garments) {
    return (garments || []).some(isPromotionalItem);
  }

  function choicesForLine(line) {
    var raw = line && line.getAttribute && line.getAttribute("data-ezink-art-specs");
    if (!raw) return null;
    try {
      var parsed = JSON.parse(raw);
      var names = [];
      (parsed.locations || []).forEach(function (loc) {
        if (loc && loc.name && names.indexOf(loc.name) < 0) names.push(loc.name);
      });
      return names.length ? names : null;
    } catch (err) {
      return null;
    }
  }

  function fillLineLocSelect(sel, names) {
    if (!sel || !names || !names.length) return;
    var current = sel.value;
    sel.innerHTML = names.map(function (name) {
      return '<option value="' + String(name).replace(/"/g, "&quot;") + '">' + name + "</option>";
    }).join("");
    if (current) {
      var known = false;
      Array.prototype.forEach.call(sel.options, function (opt) {
        if (opt.value === current) known = true;
      });
      if (!known) sel.insertBefore(new Option(current, current, true, true), sel.firstChild);
      else sel.value = current;
    }
  }
  var TYPE_IDS = {
    "Wearable 1 Color": "WE1",
    "Wearable": "WE",
    "DTF": "DF",
    "LoMelt 1 Color": "LM1",
    "LoMelt": "LM",
    "Blocker 1 Color": "BL1",
    "Blocker": "BL",
    "Soft Shell Blocker 1 Color": "SB1",
    "Soft Shell Blocker": "SB",
    "LoMelt Blocker 1 Color": "LB1",
    "LoMelt Blocker": "LB",
    "Headwear 1 Color": "HW1",
    "Headwear": "HW",
    "Reflective": "SR",
    "Promo 1 Color": "PR1",
    "Promo": "PR",
    "Neon": "NE",
    "Neon Blocker": "NB"
  };

  function typeIdForLabel(label) {
    var name = String(label || "").trim();
    if (typeof window !== "undefined" && window.EZINKHtv && window.EZINKHtv.types) {
      var types = window.EZINKHtv.types;
      for (var i = 0; i < types.length; i++) {
        if (types[i] && types[i].label === name) return types[i].id;
      }
    }
    return TYPE_IDS[name] || "WE1";
  }

  function oldLocName(label) {
    var name = String(label || "").trim().split(" ezart:")[0].split(" ezlink:")[0].trim();
    var times = name.indexOf("×");
    if (times < 0) return name;
    var words = name.slice(0, times).trim().split(/\s+/);
    if (words.length > 1) words.pop();
    return words.join(" ") || name.slice(0, times).trim();
  }

  function printBlockLoc(key) {
    if (key.indexOf("_Print | ") === 0) return key.slice("_Print | ".length).trim();
    if (key.indexOf("Print | ") === 0) return key.slice("Print | ".length).trim();
    return "";
  }

  function locationsFromProps(props) {
    props = props || {};
    var blocks = [];
    var seen = {};
    Object.keys(props).forEach(function (key) {
      var loc = printBlockLoc(key);
      if (!loc || !props[key] || seen[loc]) return;
      var hidden = props["_Print | " + loc];
      var pub = props["Print | " + loc];
      var block = hidden || pub;
      if (hidden && pub && String(pub).indexOf("custom.ez-ink.com/shopify/artwork/") !== -1 && String(hidden).indexOf("custom.ez-ink.com/shopify/artwork/") === -1) {
        block = pub;
      }
      seen[loc] = true;
      blocks.push({ loc: loc, block: String(block) });
    });
    if (blocks.length) {
      var order = String(props["_Artwork locations"] || props["Artwork locations"] || "").split(";").map(function (part) { return part.trim(); });
      blocks.sort(function (a, b) {
        var ia = order.indexOf(a.loc);
        var ib = order.indexOf(b.loc);
        if (ia < 0) ia = 999;
        if (ib < 0) ib = 999;
        return ia - ib;
      });
      return blocks.map(function (entry) {
        var parsed = parseArtBlock(entry.block);
        var bits = String(parsed.size || "").split(" · ");
        var fileUrl = "";
        var linkUrl = "";
        (parsed.urls || []).forEach(function (url) {
          if (/custom\.ez-ink\.com|cdn\.shopify\.com|\/shopify\/artwork\/|\/s\/files\//i.test(url)) {
            if (!fileUrl) fileUrl = url;
          } else if (!linkUrl) linkUrl = url;
        });
        var slug = locSlug(entry.loc);
        return {
          loc: entry.loc,
          slug: slug,
          sizeLabel: bits[0] || "",
          typeLabel: bits.slice(1).join(" · "),
          fileUrl: fileUrl,
          linkUrl: linkUrl,
          fileName: parsed.fileName || fileNameFromUrl(fileUrl) || fileNameFromUrl(linkUrl),
          notes: parsed.notes || "",
          token: props["_artwork_" + slug] || ""
        };
      });
    }
    var source = props["_Artwork locations"] || props["Artwork locations"] || props.Decoration || props._Decoration || "";
    var rows = [];
    String(source).split(";").forEach(function (part) {
      var loc = oldLocName(part);
      if (!loc) return;
      var slug = locSlug(loc);
      var sizeLabel = props["Print size " + loc] || props["Size — " + loc] || "";
      var typeLabel = props["Print type " + loc] || props["Print type — " + loc] || "";
      var link = props["Artwork link " + loc] || props["Artwork link — " + loc] || props["_artlink_" + slug] || "";
      rows.push({
        loc: loc,
        slug: slug,
        sizeLabel: sizeLabel,
        typeLabel: typeLabel,
        fileUrl: "",
        linkUrl: link ? publicArtUrl(link) : "",
        fileName: fileNameFromUrl(link),
        notes: props["Artwork notes " + loc] || props["Artwork notes — " + loc] || "",
        token: props["_artwork_" + slug] || ""
      });
    });
    return rows;
  }

  function uniqueLocName(names, base, current) {
    var used = {};
    (names || []).forEach(function (name) {
      if (name && name !== current) used[name] = true;
    });
    var clean = String(base || "").replace(/\s+/g, " ").trim();
    if (!clean) return "";
    if (!used[clean]) return clean;
    var n = 2;
    while (used[clean + " " + n]) n += 1;
    return clean + " " + n;
  }

  function dropBlankAck(props) {
    if (props) delete props["Blank acknowledgment"];
    return props;
  }

  function stripArtKeys(props) {
    Object.keys(props).forEach(function (key) {
      if (
        key === "Print" ||
        key === "Decoration" ||
        key === "_Decoration" ||
        key === "Artwork locations" ||
        key === "_Artwork locations" ||
        key === "_artfiles" ||
        key === "_deco_each" ||
        key.indexOf("Print | ") === 0 ||
        key.indexOf("_Print | ") === 0 ||
        key.indexOf("_artwork_") === 0 ||
        key.indexOf("_shopfile_") === 0 ||
        key.indexOf("_artlink_") === 0 ||
        key.indexOf("_artname_") === 0 ||
        key.indexOf("artwork_") === 0 ||
        key.indexOf("Print size ") === 0 ||
        key.indexOf("_Print size ") === 0 ||
        key.indexOf("Print type ") === 0 ||
        key.indexOf("_Print type ") === 0 ||
        key.indexOf("Transfer ") === 0 ||
        key.indexOf("Artwork notes ") === 0 ||
        key.indexOf("Artwork link ") === 0 ||
        key.indexOf("Artwork file ") === 0 ||
        key.indexOf("Art file ") === 0 ||
        key.indexOf("Size — ") === 0 ||
        key.indexOf("Print type — ") === 0 ||
        key.indexOf("Artwork notes — ") === 0 ||
        key.indexOf("Artwork link — ") === 0 ||
        key.indexOf("Artwork — ") === 0
      ) delete props[key];
    });
  }

  function decorationSpecs(rows) {
    return (rows || []).map(function (row) {
      var match = String(row.sizeLabel || "").match(/(\d+(?:\.\d+)?)\s*[×x]\s*(\d+(?:\.\d+)?)/i);
      if (!match) return null;
      return {
        w: Number(match[1]),
        h: Number(match[2]),
        type: typeIdForLabel(row.typeLabel),
        label: row.loc,
        sizeLabel: row.sizeLabel
      };
    }).filter(Boolean);
  }

  function artProp(props, name) {
    if (!props) return "";
    if (props[name] != null && props[name] !== "") return String(props[name]);
    var hidden = "_" + name;
    if (props[hidden] != null && props[hidden] !== "") return String(props[hidden]);
    return "";
  }

  function isDecorationLine(props) {
    props = props || {};
    if (props._print_adjust || props["_print_adjust"]) return false;
    if (artProp(props, "Location") === "Extra placement") return true;
    var hasBlock = Object.keys(props).some(function (key) { return printBlockLoc(key) !== ""; });
    return !!(artProp(props, "Print size") && !artProp(props, "Artwork locations") && !hasBlock);
  }

  function sameLoc(a, b) {
    return String(a || "").replace(/\s+/g, " ").trim().toLowerCase() === String(b || "").replace(/\s+/g, " ").trim().toLowerCase();
  }

  function planFileReplace(items, setId, patches, buildLines, decoEach, rightsText) {
    var members = (items || []).filter(function (item) {
      var props = artworkProps(item && item.properties);
      return (props["_Artwork set"] || item.key) === setId;
    });
    var garments = members.filter(function (item) {
      var props = artworkProps(item.properties);
      return !isDecorationLine(props) && !props._print_adjust;
    });
    if (!garments.length) return { error: "This set is no longer in the cart." };
    var rows = locationsFromProps(artworkProps(garments[0].properties));
    var replaced = [];
    (patches || []).forEach(function (patch) {
      if (!patch) return;
      var loc = String(patch.loc || "").replace(/\s+/g, " ").trim();
      if (!loc) return;
      var hasFile = !!patch.fileUrl;
      var hasLink = !!patch.linkUrl;
      if (!hasFile && !hasLink) return;
      var idx = -1;
      rows.forEach(function (row, i) {
        if (sameLoc(row.loc, loc)) idx = i;
      });
      if (idx < 0) {
        rows.push({
          loc: loc,
          slug: locSlug(loc),
          sizeLabel: patch.sizeLabel || "",
          typeLabel: patch.typeLabel || "",
          fileUrl: patch.fileUrl || "",
          linkUrl: patch.linkUrl || "",
          fileName: patch.fileName || fileNameFromUrl(patch.fileUrl) || fileNameFromUrl(patch.linkUrl),
          notes: patch.notes || "",
          token: patch.token || ""
        });
        return;
      }
      var row = rows[idx];
      var hadArt = !!(row.fileUrl || row.linkUrl || row.fileName || row.token);
      if (hasFile) {
        row.fileUrl = patch.fileUrl;
        row.fileName = patch.fileName || fileNameFromUrl(patch.fileUrl) || row.fileName;
        if (patch.token) row.token = patch.token;
        if (!hasLink) row.linkUrl = "";
        if (hadArt && replaced.indexOf(row.loc) < 0) replaced.push(row.loc);
      }
      if (hasLink) {
        var hadLink = !!row.linkUrl;
        row.linkUrl = patch.linkUrl;
        if (hadLink && replaced.indexOf(row.loc) < 0) replaced.push(row.loc);
      }
      if (patch.notes) row.notes = patch.notes;
      if (patch.sizeLabel) row.sizeLabel = patch.sizeLabel;
      if (patch.typeLabel) row.typeLabel = patch.typeLabel;
      row.slug = locSlug(row.loc);
    });
    var qty = 0;
    garments.forEach(function (item) { qty += parseInt(item.quantity, 10) || 0; });
    var specs = decorationSpecs(rows);
    var addLines = [];
    var skipCharge = lineSkipsPrintCharge(garments);
    if (rows.length && !skipCharge) {
      if (typeof buildLines !== "function") return { error: "Could not recalculate the print charge." };
      if (specs.length !== rows.length) return { error: "Enter a print size for each artwork location." };
      var built = buildLines(qty, specs) || [];
      if (!built.length) return { error: "Could not recalculate the print charge." };
      built.forEach(function (line) {
        var props = artworkProps(line.properties);
        props["_Artwork set"] = setId;
        props["_set_qty"] = String(qty);
        addLines.push({ id: line.id, quantity: line.quantity, properties: props });
      });
    }
    var each = !skipCharge && decoEach > 0 && rows.length ? String(decoEach) : "";
    var garmentJobs = garments.map(function (item) {
      var props = artworkProps(item.properties);
      stripArtKeys(props);
      if (rows.length) {
        stampArt(props, rows);
        rows.forEach(function (row) {
          if (row.token) props["_artwork_" + row.slug] = String(row.token);
        });
        var pack = [];
        rows.forEach(function (row) {
          if (props["_artwork_" + row.slug]) pack.push(row.slug + "=" + props["_artwork_" + row.slug]);
        });
        if (pack.length) props._artfiles = pack.join("|").slice(0, 500);
        if (each) props._deco_each = each;
        if (rightsText) props["Artwork rights"] = String(rightsText);
      }
      if (qty > 0) props._set_qty = String(qty);
      dropBlankAck(props);
      return { id: item.key, quantity: parseInt(item.quantity, 10) || 0, properties: props };
    });
    return {
      garments: garmentJobs,
      removeKeys: members.filter(function (item) { return isDecorationLine(artworkProps(item.properties)); }).map(function (item) { return item.key; }),
      addLines: addLines,
      specs: specs,
      rows: rows,
      replaced: replaced
    };
  }

  function applyCartArtwork(setId, patches, rightsText) {
    var chain = Promise.resolve();
    (patches || []).forEach(function (patch) {
      if (!patch || !patch.file) return;
      chain = chain.then(function () {
        return uploadArtFile(patch.file).then(function (info) {
          var token = artToken(info.url);
          var packed = token.indexOf("/") >= 0 ? token.replace("/", ":") : token;
          if (!packed) throw new Error("Artwork upload did not return a file link");
          patch.token = packed;
          patch.fileUrl = publicArtUrl(info.url);
          patch.fileName = info.name || (patch.file && patch.file.name) || patch.fileName || "";
        });
      });
    });
    return chain.then(function () {
      return fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
        .then(cartJson)
        .then(function (cart) {
          var items = (cart && cart.items) || [];
          var probe = planFileReplace(items, setId, patches, function () { return [{}]; }, 0, rightsText);
          if (probe.error) throw new Error(probe.error);
          var qty = 0;
          (probe.garments || []).forEach(function (job) { qty += job.quantity || 0; });
          var decoEach = 0;
          var build = null;
          if (probe.rows && probe.rows.length && window.EZINKHtv && typeof window.EZINKHtv.cartLines === "function") {
            build = function (q, specs) { return window.EZINKHtv.cartLines(q, specs); };
            if (typeof window.EZINKHtv.packDecorationCents === "function") {
              decoEach = window.EZINKHtv.packDecorationCents(qty || 1, probe.specs || []) || 0;
            }
          }
          var plan = planFileReplace(items, setId, patches, build, decoEach, rightsText);
          if (plan.error) throw new Error(plan.error);
          var seq = Promise.resolve();
          (plan.garments || []).forEach(function (job) {
            seq = seq.then(function () { return postCart("/cart/change.js", job); });
          });
          (plan.addLines || []).forEach(function (line) {
            seq = seq.then(function () { return postCart("/cart/add.js", line); });
          });
          (plan.removeKeys || []).forEach(function (key) {
            seq = seq.then(function () { return postCart("/cart/change.js", { id: key, quantity: 0 }); });
          });
          return seq.then(function () {
            window.location.reload();
            return plan;
          });
        });
    });
  }

  function planLocationChange(items, setId, action, buildLines) {
    var members = (items || []).filter(function (item) {
      var props = artworkProps(item && item.properties);
      return (props["_Artwork set"] || item.key) === setId;
    });
    var garments = members.filter(function (item) {
      var props = artworkProps(item.properties);
      return !isDecorationLine(props) && !props._print_adjust;
    });
    if (!garments.length) return { error: "This set is no longer in the cart." };
    var rows = locationsFromProps(artworkProps(garments[0].properties));
    if (action && action.type === "delete") {
      var kept = rows.filter(function (row) { return row.loc !== action.loc; });
      if (kept.length === rows.length) return { error: "That location is no longer on this set." };
      rows = kept;
    } else {
      var from = action && action.from;
      var wanted = uniqueLocName(rows.map(function (row) { return row.loc; }), action && action.to, from);
      if (!wanted) return { error: "Enter a location." };
      var idx = -1;
      rows.forEach(function (row, i) { if (row.loc === from) idx = i; });
      if (idx < 0) return { error: "That location is no longer on this set." };
      if (wanted === rows[idx].loc) return { unchanged: true };
      rows[idx].loc = wanted;
      rows[idx].slug = locSlug(wanted);
    }
    var qty = 0;
    garments.forEach(function (item) { qty += parseInt(item.quantity, 10) || 0; });
    var specs = decorationSpecs(rows);
    var addLines = [];
    var skipCharge = lineSkipsPrintCharge(garments);
    if (rows.length && !skipCharge) {
      if (typeof buildLines !== "function") return { error: "Could not recalculate the print charge." };
      if (specs.length !== rows.length) return { error: "Could not read the print size on this set." };
      var built = buildLines(qty, specs) || [];
      if (!built.length) return { error: "Could not recalculate the print charge." };
      built.forEach(function (line) {
        var props = artworkProps(line.properties);
        props["_Artwork set"] = setId;
        props["_set_qty"] = String(qty);
        addLines.push({
          id: line.id,
          quantity: line.quantity,
          properties: props
        });
      });
    }
    var decoEach = !skipCharge && action && action.decoEach > 0 && rows.length ? String(action.decoEach) : "";
    var garmentJobs = garments.map(function (item) {
      var props = artworkProps(item.properties);
      stripArtKeys(props);
      if (rows.length) {
        stampArt(props, rows);
        rows.forEach(function (row) {
          if (row.token) props["_artwork_" + row.slug] = String(row.token);
        });
        var pack = [];
        rows.forEach(function (row) {
          if (props["_artwork_" + row.slug]) pack.push(row.slug + "=" + props["_artwork_" + row.slug]);
        });
        if (pack.length) props._artfiles = pack.join("|").slice(0, 500);
        if (decoEach) props._deco_each = decoEach;
      }
      if (qty > 0) props._set_qty = String(qty);
      dropBlankAck(props);
      return { id: item.key, quantity: parseInt(item.quantity, 10) || 0, properties: props };
    });
    return {
      garments: garmentJobs,
      removeKeys: members.filter(function (item) { return isDecorationLine(artworkProps(item.properties)); }).map(function (item) { return item.key; }),
      addLines: addLines,
      specs: specs,
      rows: rows
    };
  }

  function bootCartLocations() {
    var form = document.querySelector("form[data-ezink-cart-artwork]");
    if (!form || form.getAttribute("data-ezink-loc-ready") === "1") return;
    form.setAttribute("data-ezink-loc-ready", "1");
    var busy = false;
    form.querySelectorAll("[data-ezink-line]").forEach(function (line) {
      var names = choicesForLine(line);
      if (!names) return;
      line.querySelectorAll("[data-ezink-loc-select]").forEach(function (sel) {
        fillLineLocSelect(sel, names);
      });
    });

    function lineOf(node) {
      return node && node.closest ? node.closest("[data-ezink-line]") : null;
    }

    function postJson(url, body) {
      return fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        credentials: "same-origin",
        body: JSON.stringify(body)
      }).then(function (res) {
        return res.json().then(function (payload) {
          if (!res.ok) throw new Error((payload && (payload.description || payload.message)) || "Could not update the artwork");
          return payload;
        });
      });
    }

    function runPlan(plan) {
      var chain = Promise.resolve();
      (plan.garments || []).forEach(function (job) {
        chain = chain.then(function () { return postJson("/cart/change.js", job); });
      });
      (plan.addLines || []).forEach(function (line) {
        chain = chain.then(function () { return postJson("/cart/add.js", line); });
      });
      (plan.removeKeys || []).forEach(function (key) {
        chain = chain.then(function () {
          var body = { id: key, quantity: 0 };
          return postJson("/cart/change.js", body).catch(function () {
            return postJson("/cart/change.js", body);
          });
        });
      });
      return chain.then(function () { window.location.reload(); });
    }

    function unlock() {
      busy = false;
      form.removeAttribute("aria-busy");
    }

    function changeLocation(setId, action) {
      if (busy) return;
      busy = true;
      form.setAttribute("aria-busy", "true");
      var mutated = false;
      fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var probe = planLocationChange(cart.items || [], setId, action, function () { return [{}]; });
          if (probe && probe.error) throw new Error(probe.error);
          if (probe && probe.unchanged) return null;
          var qty = 0;
          (probe.garments || []).forEach(function (job) { qty += job.quantity || 0; });
          var decoEach = 0;
          var build = null;
          if (probe.rows && probe.rows.length && window.EZINKHtv && typeof window.EZINKHtv.cartLines === "function") {
            build = function (q, specs) { return window.EZINKHtv.cartLines(q, specs); };
            if (typeof window.EZINKHtv.packDecorationCents === "function") {
              decoEach = window.EZINKHtv.packDecorationCents(qty || 1, probe.specs || []) || 0;
            }
          }
          var plan = planLocationChange(cart.items || [], setId, {
            type: action.type,
            from: action.from,
            to: action.to,
            loc: action.loc,
            decoEach: decoEach
          }, build);
          if (plan.error) throw new Error(plan.error);
          if (plan.unchanged) return null;
          mutated = true;
          return runPlan(plan);
        })
        .then(function () {
          if (!mutated) unlock();
        })
        .catch(function (err) {
          var msg = (err && err.message) || "Could not update that location.";
          if (mutated) {
            window.alert(msg + " Refreshing the cart so the print charges match.");
            window.location.reload();
            return;
          }
          unlock();
          window.alert(msg);
        });
    }

    document.addEventListener("click", function (evt) {
      function locBtn(name) {
        var el = evt.target && evt.target.closest && evt.target.closest("button[data-ezink-loc-" + name + "]");
        if (!el || el === form) return null;
        return el;
      }
      var edit = locBtn("edit");
      var del = locBtn("delete");
      var save = locBtn("save");
      var cancel = locBtn("cancel");
      if (!edit && !del && !save && !cancel) return;
      if (!form.contains(evt.target)) return;
      evt.preventDefault();
      evt.stopPropagation();
      if (evt.stopImmediatePropagation) evt.stopImmediatePropagation();
      var card = evt.target.closest(".ezink-art__loc-card");
      var line = lineOf(card || evt.target);
      if (!card || !line) return;
      var loc = card.getAttribute("data-loc") || "";
      var setId = line.getAttribute("data-art-set") || line.getAttribute("data-key") || "";
      if (cancel) {
        var editor = card.querySelector("[data-ezink-loc-editor]");
        if (editor) editor.hidden = true;
        return;
      }
      if (edit) {
        var panel = card.querySelector("[data-ezink-loc-editor]");
        var sel = panel && panel.querySelector("[data-ezink-loc-select]");
        if (!panel || !sel) return;
        var names = choicesForLine(line);
        if (names) fillLineLocSelect(sel, names);
        var known = false;
        Array.prototype.forEach.call(sel.options, function (opt) {
          if (opt.value === loc) known = true;
        });
        if (!known) {
          var base = loc.replace(/ \d+$/, "");
          var baseOpt = Array.prototype.filter.call(sel.options, function (opt) { return opt.value === base; })[0];
          if (baseOpt) baseOpt.selected = true;
          else sel.insertBefore(new Option(loc, loc, true, true), sel.querySelector('option[value="Other"]'));
        } else {
          sel.value = loc;
        }
        var other = panel.querySelector("[data-ezink-loc-other]");
        if (other) {
          other.hidden = sel.value !== "Other";
          if (sel.value === "Other") other.value = loc;
        }
        panel.hidden = false;
        return;
      }
      if (save) {
        var box = card.querySelector("[data-ezink-loc-editor]");
        var choice = box.querySelector("[data-ezink-loc-select]");
        var custom = box.querySelector("[data-ezink-loc-other]");
        var next = choice && choice.value === "Other" ? (custom && custom.value) : (choice && choice.value);
        changeLocation(setId, { type: "rename", from: loc, to: String(next || "").trim() });
        return;
      }
      var cards = line.querySelectorAll(".ezink-art__loc-card");
      var promoLine = (line.getAttribute("data-ezink-type") || "") === "Promotional" || !!choicesForLine(line);
      var msg = promoLine
        ? (cards.length < 2 ? "Remove " + loc + "?" : "Remove " + loc + " from this set?")
        : (cards.length < 2
          ? "Remove " + loc + "? It is the only artwork location, so the print charges come off this set."
          : "Remove " + loc + " from this set? That location's print comes off the order.");
      if (!window.confirm(msg)) return;
      changeLocation(setId, { type: "delete", loc: loc });
    }, true);

    document.addEventListener("change", function (evt) {
      var sel = evt.target;
      if (!sel || !sel.matches || !sel.matches("[data-ezink-loc-select]")) return;
      var box = sel.closest("[data-ezink-loc-editor]");
      var other = box && box.querySelector("[data-ezink-loc-other]");
      if (!other) return;
      other.hidden = sel.value !== "Other";
      if (sel.value === "Other") other.focus();
    });
  }

  var api = {
    addToCart: addToCart,
    collectArtwork: collectArtwork,
    buildArtSummary: buildArtSummary,
    parseArtBlock: parseArtBlock,
    planArtworkQtyUpdates: planArtworkQtyUpdates,
    planDecorationRebuild: planDecorationRebuild,
    artworkSetQtyJobs: artworkSetQtyJobs,
    locationsFromProps: locationsFromProps,
    planLocationChange: planLocationChange,
    decorationSpecs: decorationSpecs,
    planCheckoutOrder: planCheckoutOrder,
    setLabelForItems: setLabelForItems,
    setLabelJobs: setLabelJobs,
    isDecorationItem: isDecorationItem,
    cartArtProps: cartArtProps,
    planFileReplace: planFileReplace,
    applyCartArtwork: applyCartArtwork,
    previewFilePlan: previewFilePlan,
    orderFacingProps: orderFacingProps
  };
  if (typeof window !== "undefined") window.EZINKSizeQtyCart = api;
  if (typeof module !== "undefined" && module.exports) module.exports = api;

  if (typeof document !== "undefined") {
    function stampSetLabels() {
      if (!document.querySelector("form[data-ezink-cart-artwork]")) return;
      fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
        .then(function (res) { return cartJson(res); })
        .then(function (cart) {
          var jobs = setLabelJobs((cart && cart.items) || []);
          var chain = Promise.resolve();
          jobs.forEach(function (job) {
            chain = chain.then(function () { return postCart("/cart/change.js", job); });
          });
          return chain;
        })
        .catch(function () { return null; });
    }

    function bootAll() {
      boot();
      bootCartLocations();
      var pending = bootCartQtySync();
      Promise.resolve(pending).then(function (action) {
        if (action === "reload") return;
        stampSetLabels();
      }, function () {
        stampSetLabels();
      });
    }
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", bootAll);
    else bootAll();
  }
})();
